module.exports = __webpack_public_path__ + "img/dr-gary-richter-logo.db3311c9.png";